import { render, staticRenderFns } from "./BaseNull.vue?vue&type=template&id=48bacc87&scoped=true"
import script from "./BaseNull.vue?vue&type=script&lang=js"
export * from "./BaseNull.vue?vue&type=script&lang=js"
import style0 from "./BaseNull.vue?vue&type=style&index=0&id=48bacc87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bacc87",
  null
  
)

export default component.exports